import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './App.css';
import WelcomePopup from './components/WelcomePopup';
import { galleryImages, MISSION_1, MISSION_2 } from './constants/images';
import { getHomeCarouselFotos } from './services/galeriaService';
import DonateSection from './components/DonateSection';
import HeroVideo from './components/HeroVideo';
import {
  PHONE_DISPLAY,
  WHATSAPP_DISPLAY,
  WHATSAPP_URL,
  EMAIL,
  LOCATION,
  SOCIAL_LINKS,
} from './constants/contact';
import {
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaTimes,
  FaChevronLeft,
  FaChevronRight,
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaTiktok,
  FaWhatsapp,
} from 'react-icons/fa';

function Home() {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState({ type: '', message: '' });
  const [currentSlide, setCurrentSlide] = useState(0);
  const [carouselImages, setCarouselImages] = useState([]);
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    mensaje: '',
  });

  useEffect(() => {
    getHomeCarouselFotos()
      .then((data) => {
        if (data && data.length > 0) {
          setCarouselImages(data.map((f) => ({ src: f.image_url, alt: f.title || 'Mitzva Tank' })));
        } else {
          setCarouselImages(galleryImages.map((src, i) => ({ src, alt: `Mitzva Tank ${i + 1}` })));
        }
      })
      .catch(() => {
        setCarouselImages(galleryImages.map((src, i) => ({ src, alt: `Mitzva Tank ${i + 1}` })));
      });
  }, []);

  useEffect(() => {
    if (carouselImages.length === 0) return;
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [carouselImages.length]);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -100px 0px',
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, observerOptions);

    const animatedElements = document.querySelectorAll('.animate-on-scroll:not(.visible)');
    animatedElements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, [carouselImages]);

  useEffect(() => {
    if (window.location.hash) {
      const sectionId = window.location.hash.replace('#', '');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, []);

  const handleFormChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    const formDataToSend = new FormData(e.target);
    formDataToSend.append('access_key', '3afecf6c-1e49-4371-a3fb-102239eefdca');

    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        body: formDataToSend,
      });

      const data = await response.json();

      if (data.success) {
        setModalMessage({
          type: 'success',
          message: '¡Gracias por contactarnos! Hemos recibido tu mensaje y te responderemos pronto.',
        });
        setShowModal(true);
        setFormData({ nombre: '', email: '', telefono: '', mensaje: '' });
      } else {
        setModalMessage({
          type: 'error',
          message: 'Hubo un error al enviar el mensaje. Por favor, intenta nuevamente.',
        });
        setShowModal(true);
      }
    } catch (error) {
      setModalMessage({
        type: 'error',
        message: 'Hubo un error al enviar el mensaje. Por favor, verifica tu conexión e intenta nuevamente.',
      });
      setShowModal(true);
    }
  };

  const closeModal = () => setShowModal(false);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + carouselImages.length) % carouselImages.length);
  };

  const goToSlide = (index) => setCurrentSlide(index);

  return (
    <div className="App">
      <WelcomePopup />
      {showModal && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>
              <FaTimes />
            </button>
            <div className={`modal-icon ${modalMessage.type}`}>
              {modalMessage.type === 'success' ? (
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                </svg>
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
                </svg>
              )}
            </div>
            <h3 className="modal-title">
              {modalMessage.type === 'success' ? '¡Mensaje enviado!' : 'Error al enviar'}
            </h3>
            <p className="modal-message">{modalMessage.message}</p>
            <button className="modal-button" onClick={closeModal}>
              Aceptar
            </button>
          </div>
        </div>
      )}

      <section id="inicio" className="hero">
        <HeroVideo />
        <div className="hero-content">
          <h1 className="hero-title">Acercando la Torá y las Mitzvot</h1>
          <p className="hero-subtitle">
            El departamento de Jabad Argentina para llevar luz y tradición al interior del país. Mirá cómo conectamos a los yehudim de cada comunidad y de cada lugar con su propia esencia y herencia milenaria
          </p>
          <button className="btn btn-primary" onClick={() => navigate('/campanas')}>
            Descubrí nuestras campañas
          </button>
        </div>
      </section>

      <DonateSection />

      <section id="mision" className="mission">
        <div className="container">
          <div className="mission-grid">
            <div className="mission-content animate-on-scroll">
              <h2 className="section-title">Nuestra Misión</h2>
              <p className="mission-text">
                El Rebe de Lubavitch, Rabí Menajem Mendel Schneerson, se preocupó por cada judío,
                sin importar su ubicación. Siguiendo esta visión sagrada, <strong>Mitzva Tank</strong> recorre
                Argentina acercando las mitzvot y fortaleciendo la identidad judía en cada comunidad.
              </p>
              <p className="mission-text">
                Nuestro objetivo es llegar a cada judío, dondequiera que esté, y ofrecerle la oportunidad
                de cumplir con las mitzvot y conectarse con sus raíces espirituales. Llevamos luz, alegría
                y tradición a través de nuestras 10 campañas especiales.
              </p>
              <div className="mission-quote">
                <p>"Hace muchos años existe en el mundo el concepto de tanques de guerra, algo que genera mal y dolor.
                Justamente por eso es que hace falta su contraparte del Bien, un tanque de santidad."</p>
              </div>
            </div>
            <div className="mission-images animate-on-scroll">
              <img src={MISSION_1} alt="Mitzva Tank" className="mission-img" loading="lazy" decoding="async" />
              <img src={MISSION_2} alt="Actividades" className="mission-img" loading="lazy" decoding="async" />
            </div>
          </div>
        </div>
      </section>

      <section id="video" className="video-section">
        <div className="container">
          <h2 className="section-title animate-on-scroll">Conoce más sobre nuestra labor</h2>
          <p className="section-subtitle animate-on-scroll">Mira cómo llevamos las mitzvot a cada comunidad</p>
          <div className="video-container animate-on-scroll">
            <iframe
              width="100%"
              height="500"
              src="https://www.youtube.com/embed?v=nor3cO-W4_o&list=PLUDG13mEj8Di_dRPM6usmHZG79eTBpV-_&index=11"
              title="Mitzva Tank Video"
              frameBorder="0"
              allow="autoplay"
              allowFullScreen
              style={{ borderRadius: '15px' }}
            ></iframe>
          </div>
        </div>
      </section>

      {carouselImages.length > 0 && (
        <section className="gallery">
          <div className="container">
            <h2 className="section-title animate-on-scroll">Nuestra labor en imágenes</h2>
            <div className="carousel-container animate-on-scroll">
              <div className="carousel-wrapper">
                <button className="carousel-btn carousel-btn-prev" onClick={prevSlide}>
                  <FaChevronLeft />
                </button>

                <div className="carousel-slides">
                  <div className="carousel-slide active">
                    <img
                      src={carouselImages[currentSlide]?.src}
                      alt={carouselImages[currentSlide]?.alt}
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                </div>

                <button className="carousel-btn carousel-btn-next" onClick={nextSlide}>
                  <FaChevronRight />
                </button>
              </div>

              <div className="carousel-dots">
                {carouselImages.map((_, index) => (
                  <button
                    key={index}
                    className={`carousel-dot ${index === currentSlide ? 'active' : ''}`}
                    onClick={() => goToSlide(index)}
                  />
                ))}
              </div>
            </div>
          </div>
        </section>
      )}

      <section id="contacto" className="contact">
        <div className="container">
          <h2 className="section-title animate-on-scroll">Contactanos</h2>
          <p className="section-subtitle animate-on-scroll">¿Tenes preguntas? ¿Queres que visitemos tu comunidad? ¡Escribinos!</p>
          <div className="contact-grid">
            <div className="contact-info animate-on-scroll">
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="contact-item contact-item-link">
                <FaWhatsapp className="contact-icon" style={{ color: '#25D366' }} />
                <div>
                  <h3>WhatsApp</h3>
                  <p>{WHATSAPP_DISPLAY}</p>
                </div>
              </a>
              <div className="contact-item">
                <FaPhone className="contact-icon" />
                <div>
                  <h3>Teléfono</h3>
                  <p>{PHONE_DISPLAY}</p>
                </div>
              </div>
              <div className="contact-item">
                <FaEnvelope className="contact-icon" />
                <div>
                  <h3>Email</h3>
                  <p>{EMAIL}</p>
                </div>
              </div>
              <div className="contact-item">
                <FaMapMarkerAlt className="contact-icon" />
                <div>
                  <h3>Ubicación</h3>
                  <p>{LOCATION}</p>
                </div>
              </div>
              <div className="social-links">
                <a href={SOCIAL_LINKS.facebook} target="_blank" rel="noopener noreferrer" className="social-link" title="Facebook">
                  <FaFacebook />
                </a>
                <a href={SOCIAL_LINKS.instagram} target="_blank" rel="noopener noreferrer" className="social-link" title="Instagram">
                  <FaInstagram />
                </a>
                <a href={SOCIAL_LINKS.youtube} target="_blank" rel="noopener noreferrer" className="social-link" title="YouTube">
                  <FaYoutube />
                </a>
                <a href={SOCIAL_LINKS.tiktok} target="_blank" rel="noopener noreferrer" className="social-link" title="TikTok">
                  <FaTiktok />
                </a>
                <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="social-link" title="WhatsApp">
                  <FaWhatsapp />
                </a>
              </div>
            </div>
            <form className="contact-form animate-on-scroll" onSubmit={handleFormSubmit}>
              <input
                type="text"
                name="nombre"
                placeholder="Nombre completo"
                value={formData.nombre}
                onChange={handleFormChange}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleFormChange}
                required
              />
              <input
                type="tel"
                name="telefono"
                placeholder="Teléfono"
                value={formData.telefono}
                onChange={handleFormChange}
              />
              <textarea
                name="mensaje"
                placeholder="Mensaje"
                rows="5"
                value={formData.mensaje}
                onChange={handleFormChange}
                required
              ></textarea>
              <button type="submit" className="btn btn-primary">Enviar Mensaje</button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
